<template>
  <span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          class="clickable pa-1"
          v-bind="attrs"
          v-on="on"
          @click="click"
        >
          <slot />
        </v-icon>
      </template>
      <span>{{ tip }}</span>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  props: {
    tip: {
      type: String
    }
  },
  methods: {
    click() {
      this.$emit("click");
    }
  }
};
</script>

<style></style>
